import { ListTable as ListTableBase } from './ListTable';
import { ListTableCell } from './ListTable.Cell/ListTable.Cell';
import { ListTableHeader } from './ListTable.Header/ListTable.Header';
import { ListTableHeaderCell } from './ListTable.HeaderCell/ListTable.HeaderCell';
import { ListTableRow } from './ListTable.Row/ListTable.Row';
export var ListTable = Object.assign(ListTableBase, {
  Cell: ListTableCell,
  Row: ListTableRow,
  Header: ListTableHeader,
  HeaderCell: ListTableHeaderCell
});